
const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
        sorter: (a, b) => {
            const nameA = `${a?.firstName ?? ''} ${a?.lastName ?? ''}`.trim();
            const nameB = `${b?.firstName ?? ''} ${b?.lastName ?? ''}`.trim();
            return nameA.localeCompare(nameB);
        },
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: (a, b) => a.email - b.email,
    },
    {
        title: 'Phone No.',
        dataIndex: 'phoneNo',
    },
    {
        title: 'From',
        dataIndex: 'from',
        sorter: (a, b) => a.from - b.from,
    },
    {
        title: 'To',
        dataIndex: 'to',
        sorter: (a, b) => a.to - b.to,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: (a, b) => a.amount - b.amount,
    },
    {
        title: 'Request Date',
        dataIndex: 'transactionDate',
        render: defaultRender,
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }

];

export default columns;